module.exports = __webpack_public_path__ + "img/92.5.COD.8abddc51.png";